import Alert from '../Alert/Alert';

function InfoMessage(props) {
    return (
        <>
            {props.info.map((data, key) => {
                const message = data.message ? data.message : data;
                return (
                    <Alert key={key} variant="info" body={message} />
                );
            })}
        </>
    );
}

export default InfoMessage;